// extracted by mini-css-extract-plugin
module.exports = {"container":"UTMInfoField_container__14hPk","keyText":"UTMInfoField_keyText__q2UeU","valueText":"UTMInfoField_valueText__37LSv"};